import React from 'react';
import { Button, Form, Segment } from 'semantic-ui-react';
import axios from 'axios';
import { FormattedMessage } from 'react-intl';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class StudentsFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            studyType: null,
            studyProgram: null,
            firstName: null,
            lastName: null,
            index: null,
            grade: null,

            canceledGrade:null
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
        this.getStudyProgramName = this.getStudyProgramName.bind(this);
    }


    onFilterData() {
        this.props.onFilterData(
            this.state.firstName,
            this.state.lastName,
            this.state.index,
            this.state.studyProgram,
            this.state.studyType,
            this.state.grade,
            this.state.canceledGrade
        );
    }

    getStudyProgramName(id) {
        const { studyPrograms } = this.props;
        const selected = studyPrograms.find(el => el.key === id);
        if (selected && selected.text) return selected.text;
        return '';
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }


    render() {
        return (
            <Segment clearing>
                <Form>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>                                                                                                                                                                                                                                                                                                                                                                                                                                                                     {<FormattedMessage id="professorInputGrades.studentStudyType" />}</label>
                            <Form.Dropdown clearable
                                placeholder={<FormattedMessage id="professorInputGrades.selectStudyType" />}
                                value={this.state.studyType}
                                onChange={this.handleInputChange}
                                name="studyType"
                                options={this.props.studyTypes}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                    {<FormattedMessage id="professorInputGrades.studyProgram" />}</label>
                            <Form.Dropdown clearable
                                placeholder={<FormattedMessage id="professorInputGrades.selectStudyProgram" />}
                                value={this.state.studyProgram}
                                onChange={this.handleInputChange}
                                name="studyProgram"
                                options={this.props.studyPrograms}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <label> {<FormattedMessage id="common.grade" />}</label>
                            <Form.Dropdown clearable
                                placeholder={<FormattedMessage id="professorInputGrades.selectGrade" />}
                                value={this.state.grade}
                                onChange={this.handleInputChange}
                                name="grade"
                                options={this.props.marks}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>

                    </Form.Group>
                    <Form.Group widths="equal">
                        <Form.Field>
                            <label>{<FormattedMessage id="common.firstName" />}</label>
                            <FormattedMessage id="common.inputName">
                                {(msg) => (<input
                                    value={this.state.firstName}
                                    onChange={(e) => this.setState({ firstName: e.target.value })}
                                    name="firstName"
                                    placeholder={msg}
                                />)}
                            </FormattedMessage>
                        </Form.Field>

                        <Form.Field>
                            <label>{<FormattedMessage id="common.lastName" />}</label>
                            <FormattedMessage id="common.inputLastName">
                                {(msg) => (<input
                                    value={this.state.lastName}
                                    onChange={(e) => this.setState({ lastName: e.target.value })}
                                    name="lastName"
                                    placeholder={msg}
                                />)}
                            </FormattedMessage>
                        </Form.Field>

                        <Form.Field>
                            <label>{<FormattedMessage id="common.index" />}</label>
                            <FormattedMessage id="common.inputIndex">
                                {(msg) => (<input
                                    value={this.state.index}
                                    onChange={(e) => this.setState({ index: e.target.value })}
                                    name="index"
                                    placeholder={msg}
                                />)}
                            </FormattedMessage>
                        </Form.Field>

                    </Form.Group>
                    <Button color="blue" onClick={this.onFilterData}>{<FormattedMessage id="professorInputGrades.getFilter" />}
                    </Button>
                    <Button basic="true" color="blue" onClick={this.props.filtersOff}>{<FormattedMessage id="common.cancelO" />}
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Professor/ProfessorHistoryGrades/StudentsFilter.js